<template>
    <div>
        <VeeField
            ref="birth"
            v-slot="{value:fieldValue, handleChange, handleBlur, errors}"
            v-model="birthday"
            :name="name"
            :rules="validateBirthday"
            :validate-on-mount="immediate"
            @blur="birthdayToASCII"
            @update:model-value="birthdayToASCII"
        >
            <div>
                <div
                    v-if="!loginMember"
                    class="mt-[20px] md:mt-[30px] mb-[10px] font-medium"
                    :class="[
                        {'text-pink-800': !!errors[0]}, 
                        !memberStyle ? 'text-black' : 'mt-4'
                    ]"
                >
                    {{ title }} 
                    <span
                        v-if="!memberStyle"
                        class="text-pink-800"
                    >*</span>
                </div>
                <div
                    class="mt-2 flex flex-nowrap w-full gap-[10px] justify-between"
                    :class="[{'xl:mt-0': !memberStyle}]"
                >
                    <label
                        class="switch"
                        :class="[
                            !memberStyle ? 'w-1/2' : 'w-[200px]'
                        ]"
                    >
                        <input
                            v-model="isRoc"
                            type="checkbox"
                            class="switch-input"
                            :disabled="disabled"
                        >
                        <span
                            class="switch-label"
                            data-on="西元"
                            data-off="民國"
                        ></span>
                        <span class="switch-handle"></span>
                    </label>
                    <FormTextField
                        :id="id"
                        :model-value="fieldValue"
                        :max-length="isRoc ? 9 : 10"
                        :min-length="isRoc ? 6 : 8"
                        :error="!!errors[0]"
                        :error-message="errors[0]"
                        :placeholder="placeholder"
                        :disabled="disabled"
                        :class="[
                            !memberStyle ? 'w-1/2' : 'w-3/4'
                        ]"
                        @keyup="handleBlur"                        
                        @update:model-value="handleChange"
                    />
                </div>
            </div>
        </VeeField>
    </div>
</template>

<script>
import { required, rocDate, verifyDate } from '@/utils/validate.js';
import FormTextField from '@/components/forms/TextField';

export default{
    name: 'BirthdayField',
    components: { FormTextField, },
    props: {
        // 編輯style開關
        editStyle: {
            type: Boolean,
            default: false
        },
        // 直接判定錯誤開關
        immediate: {
            type: Boolean,
            default: false
        },
        // 內容
        modelValue:{
            type: String,
            default: '', 
        },
        // input id
        id: {
            type: String,
            default: 'Birthday',
        },
        // 欄位名稱
        title: {
            type: String,
            default: '出生日期'
        },
        // 檢核覽位名
        name: {
            type: String,
            default: '出生日期'
        },
        // 會員資料style
        memberStyle: {
            type: Boolean,
            default: false,
        },
        // 填寫會員資料style => 欄位title要消失
        loginMember: {
            type: Boolean,
            default: false,
        },
        // 車主資料頁編輯style
        assuredStyle: {
            type: Boolean, 
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // 是否自然人 是=>檢核規則必填
        isNature: {
            type: Boolean,
            default: true
        },
    },
    emits: ['update:modelValue'],
    data() {
        /** 
         *  @param {String} birthday 生日(西元)
         *  @param {Boolean} isRoc 西元/民國切換
         *  @param {String} placeholder 顯示YYYY/MM/DD 或 YY/MM/DD
         */
        return {
            birthday: null,
            isRoc: false, // false西元 true民國
            placeholder: 'YYYY/MM/DD',
        };
    },
    watch:{
        isRoc:{
            handler(value){
                this.placeholder = value ? 'YY/MM/DD' : 'YYYY/MM/DD';
                let birthday = null;
                if (!!this.birthday && this.validateBirthday(this.birthday, {flag: !value}) === true) {
                    birthday = value ? this.$dateTransform.ceToRoc(this.birthday).join('/') : this.$dateTransform.rocToCe(this.birthday).join('/');
                }
                this.birthday = this.validateBirthday(birthday) === true ? birthday : null;
            },
            immediate:true,
        },
        modelValue:{
            handler(value){
                if(!this.$moment(value, 'YYYY-MM-DDTHH:mm:ss', true).isValid() && !this.$moment(value, 'YYYY-MM-DD', true).isValid()){
                    this.birthday = null;
                }
                else {
                    if(this.isRoc){
                        let date = this.$moment(value).format('YYYYMMDD');
                        this.birthday = this.$dateTransform.ceToRoc(date).join('/');
                    }
                    else{
                        this.birthday = this.$moment(value).format('YYYY/MM/DD');
                    }
                }
            },
            immediate:true,
        },
        // 非自然人清空生日欄位
        isNature(value) {
            if (!value) {
                this.birthday = null;
            }
            this.$refs.birth?.validate();
        },
    },
    methods:{
        /** 生日 全形字符轉換半形字符 */
        birthdayToASCII: _.debounce(function(e) {
            if (!this.birthday) return;
            this.birthday = this.$character.toASCII(this.birthday);
            if(this.validateBirthday(this.birthday) === true){
                let birthday = this.isRoc ? this.$dateTransform.rocToCe(this.birthday).join('-') : this.birthday;
                birthday = this.$moment(birthday.replace(/\//g, '-')).format('YYYY-MM-DDT00:00:00');
                this.$emit('update:modelValue', birthday);
            }
        }, 500),
        validateBirthday(val, ctx){
            if(!this.isNature) return true;
            if(!required(val)){
                return '請輸入出生日期';
            }

            let flag = ctx?.flag !== undefined ? ctx.flag : this.isRoc;

            if((flag && !rocDate(val)) || (!flag && !verifyDate(val, {}))){
                return '出生日期格式有誤';
            }
            return true;
        },
    }
};
</script>

<style scoped lang="scss">
.switch {
    display: inline-block;
    position: relative;
    height: 40px;
    background-color: white;
    border-radius: 40px;
    cursor: pointer;
}

.switch:disabled {
    cursor: not-allowed;
}

input[type=checkbox] {
    display: none;
}

.switch-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

input {
    outline: none;
    font-size: 16px;
}

.switch-label {
    position: relative;
    z-index: 30;
    display: block;
    height: inherit;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    color: #4F4F4F;
    border-radius: inherit;
    border: 1px solid #B2B2B2;
    transition: 0.15s ease-out;
    box-sizing: border-box;
}

.switch-label:before, .switch-label:after {
    position: absolute;
    line-height: 40px;
    transition: inherit;
}

.switch-label:before {
    content: attr(data-off);
    right: 17%;
    color: #4F4F4F;
}

.switch-label:after {
    content: attr(data-on);
    left: 17%;
    color: #fff;
}

.switch-input:checked ~ .switch-label:before {
    color: #fff;
}

.switch-input:checked ~ .switch-label:after {
    color: #4F4F4F;
}

.switch-input:checked ~ .switch-handle {
    left: 50%;
}

.switch-handle {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 40px;
    background-color: #005BAC;
    border-radius: 40px;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
    transition: left 0.15s ease-out;
}
</style>